import { useEffect } from 'react';
import dynamicfunction from '../utils/dynamicfunction';
import images from '../constants/images';
import { cn, getToken } from '../utils/utils';
import { useLocation, useNavigate } from 'react-router';
import ViewReverse from './ViewReverse';
import { useSelector } from 'react-redux';
import LoaderModal from './LoaderModal';
import ViewItems from './ViewItems';
import Text from './Text';
import { fontSizes } from '../constants/constants';

const AuthWrapper = ({ children }) => {
  const navigate = useNavigate();
  const { isArabic, TextWeight } = dynamicfunction();
  const pathname = useLocation();

  const { user } = useSelector((state) => state.common);
  const { languageLoading } = useSelector((state) => state.content);


  useEffect(() => {
    if (user?.accessToken && user?.accessToken?.length > 0) {
      navigate('/funds/available-funds');
    }
  }, []);

  const showBetaBadge = (process.env.REACT_APP_ENVIRONMENT === 'PRODUCTION' && pathname?.pathname === '/')

  return (
    <>
      <ViewReverse className='w-full h-screen'>
        <div className={cn(`w-full md:w-[450px] h-full flex flex-col`, showBetaBadge && 'relative overflow-hidden')}>
          {
            showBetaBadge && (
              <ViewItems className={cn('bg-primary justify-center items-center top-6 sm:top-10 md:top-6 absolute w-2/3 sm:w-2/4', isArabic ? 'rotate-45 -right-14 sm:-right-32 md:-right-14' : '-rotate-45 -left-14 sm:-left-32 md:-left-14')}>
                <Text color={'text-white'} text={"BETA"} size={fontSizes.h28} weight={TextWeight?.medium} className={'py-2'} />
              </ViewItems>
            )
          }
          <div className='flex flex-1 justify-center items-center px-10'>{children}</div>
        </div>

        <div
          className={cn(
            'hidden md:flex flex-1 bg-no-repeat bg-cover bg-bottom flex-col justify-end py-14 px-20',
            isArabic ? 'items-end' : 'items-start',
            isArabic && 'order-last',
          )}
          style={{
            backgroundImage: `url(${images.loginBg})`,
          }}
        ></div>
      </ViewReverse>
      <LoaderModal open={languageLoading} />
    </>
  );
};

export default AuthWrapper;
